import {dashboardSlice} from "./dashboardSlice";
import {searchDocumentsExt} from "../../../../modules/App/_redux/documents/documentsCrud";

const {actions} = dashboardSlice;

export const readDocuments = (dealerLegalEntity, folderTypesExt) => dispatch => {
    dispatch(actions.documentsCall({}));
    const getDocumentsParams = {
        sort: "id,desc",
        page: 0,
        size: 15,
        status: {
            in: [
                "DRAFT",
                "READY_TO_SIGN",
                "PENDING_START_SIGN"
            ]
        },
        legalEntity: {
            "equals": dealerLegalEntity
        }

    }

    searchDocumentsExt(getDocumentsParams)
        .then(response => {
            let documents = response.data;
            dispatch(actions.documentsFetched({documents}));
        })
        .catch(error => {
            dispatch(actions.documentsError({error}));
        });
}
